module.exports = __webpack_public_path__ + "static/status_refund_failed.2c230d9f.png";